import './Analytic.css';
import { useEffect, useContext, useState, useRef } from 'react';
import { ChartContext } from '../../../context/ChartContext';
import { ChannelsContext } from '../../../context/ChannelsContext';
import { usePreference } from '../../../context/usePreference';
import { getUserPreferenceLocalStorage } from '../../../context/utils';
import { MinuteErrorMessage } from '../Minute/MinuteErrorMessage';
import { MinuteNetWorkMessage } from '../Minute/MinuteNetWorkMessage';
import { NetworkAlertContext } from '../../../context/NetworkAlertContext';
import { SelectTypeGridEnum } from '../../../utils/enums';
import { defaultColumnColors } from '../EmissoraColor/EmissoraColor';
import { ReportChartLine } from './ReportChartLine';
import { ReportChartPie } from './ReportChartPie';
import { ReportChartBar } from './ReportChartBar';

export function Analytic({ selectTypeGrid, changeSelectDiv }) {
  const { audience, doAudienceChart, qtdMinutos } = useContext(ChartContext);
  const { channels, doChannels } = useContext(ChannelsContext);
  const user = usePreference();
  const { showError, setShowError, infoError, showInfo, infoSpan } = useContext(NetworkAlertContext);
  const autoUpdateTimerRef = useRef<NodeJS.Timeout | null>(null);


  const chartTopPadding = 90;
  const RootComponent = document.getElementById("root");
  const pUiScreenWidth = parseFloat(RootComponent != undefined ? getComputedStyle(RootComponent).width : '0');
  const pColumnsCustomColors = channels?.enabled.map(x => x.color);

  let chartWidth = pUiScreenWidth - 20;
  let areaWidth = chartWidth;
  let dataElements = null;
  let textElements: any[] = [];
  let columnColors = pColumnsCustomColors ?? defaultColumnColors;
  let xLabelsSpace = chartWidth / channels?.enabled.length;
  let xValue = 10;
  let yValue = 7;
  let labelsChart: string[] = [];

  const [widthPage, setWidthPage] = useState(window.innerWidth);
  function updateWidth() {
    setWidthPage(window.innerWidth);
  }

  window.addEventListener("resize", updateWidth);


  useEffect(() => {

  }, [widthPage]);

  channels?.enabled.map((column, key) => {
    labelsChart.push(column.label);
  });

  dataElements = channels?.enabled.map((c, index) => {
    let backgroundColor = columnColors[index % columnColors.length];
    if (index > 0) {
      xValue = xValue + xLabelsSpace;
    }
    textElements.push(
      <text
        x={xValue + 25}
        y={yValue + 15}
        fill="#000"
        style={{
          fontSize: '10px'
        }}>
        {labelsChart[index]}
      </text>
    );
    return (
      <rect
        key={index}
        x={xValue}
        y={yValue}
        width='20px'
        height='20px'
        fill={backgroundColor}>
      </rect>
    );
  });

  if (channels != undefined)
    user.setLoaded(true);

  useEffect(() => {
    doChannels();
    loadAudience();
    initilizeAudienceTimer();
  }, []);

  // Cleanup timer quando componente é desmontado
  useEffect(() => {
    return () => {
      if (autoUpdateTimerRef.current) {
        clearInterval(autoUpdateTimerRef.current);
      }
    };
  }, []);

  function loadAudience() {
      doAudienceChart()
  }
  function initilizeAudienceTimer() {
    // Limpa timer anterior se existir
    if (autoUpdateTimerRef.current) {
      clearInterval(autoUpdateTimerRef.current);
      autoUpdateTimerRef.current = null;
    }

    if (user.userPreference?.ChangeAutoUpdate) {
      autoUpdateTimerRef.current = setInterval(TimerAutoUpdate, 30000);
    }
  }

  function TimerAutoUpdate() {
    const userStorage = getUserPreferenceLocalStorage();
    if (userStorage?.autoUpdate) {
      loadAudience();
    }
  }

  return (

    <div id="divAnalyticComponent" data-testid="divAnalyticComponent" style={{ width: '100%' }}>
      {showError ? <MinuteErrorMessage setShowError={setShowError} infoError={infoError} /> : ''}
      <MinuteNetWorkMessage info={showInfo} infoText={infoSpan} changeSelectDiv={changeSelectDiv} audience={audience}/>

      <div
        id="report-charts"
        style={{
          width: pUiScreenWidth,
          marginTop: 5
        }}
      >

        <ReportChartLine
          customColors={pColumnsCustomColors}
          audience={audience}
          qtyMinutes={qtdMinutos}
        />
        <div style={{ textAlign: 'center' }}>
          <svg
            width={areaWidth}
            height='35px'
            style={{
              bottom: 0,
              backgroundColor: '#fff',
              overflow: 'hidden'
            }}
          >
            <g>{dataElements}</g>
            <g>{textElements}</g>
          </svg>
        </div>
        <div
          id="divExibMinute"
          className={
            selectTypeGrid === SelectTypeGridEnum.Both || selectTypeGrid === SelectTypeGridEnum.Minute || selectTypeGrid === SelectTypeGridEnum.Image
              ? "divExib"
              : "divExibHide"
          }
        > </div>

        <ReportChartPie
          audience={audience}
          qtyMinutes={qtdMinutos}
        />

        <ReportChartBar
          customColors={pColumnsCustomColors}
          audience={audience}
          qtyMinutes={qtdMinutos}
        />
      </div>
    </div>
  );
}

export default Analytic;